<div>
    <button class="basic-button-base button-dark" (click)="triggerFileSelector($event)" [attr.disabled]="isLoading ? 'disabled': null"><i class="fal fa-spinner fa-spin" *ngIf="isLoading"></i> Select File</button>
    <input type="file" (change)="newFileDetected($event)" style="display: none">
    <span *ngFor="let fileName of fileNames" style="margin-left: 5px">{{ fileName }}</span>
</div>
